import { render, staticRenderFns } from "./VindiPlansInput.vue?vue&type=template&id=4a0c73f5"
import script from "./VindiPlansInput.vue?vue&type=script&lang=js"
export * from "./VindiPlansInput.vue?vue&type=script&lang=js"
import style0 from "./VindiPlansInput.vue?vue&type=style&index=0&id=4a0c73f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports